<template>
	<div>
		<div class="title-with-right-button-area" :ref="'detailTop'">
			<h1 v-text="isCompany ? '사업현황관리' : '내사업관리'">내사업관리</h1>
			<div class="right-box-area">
				<nav-link :click="openAgreement">
					<!--					<div class="round-box round-box-sm" v-tooltip.top-center="agreeMsg">-->
					<div class="round-box round-box-sm">
						사업비관리동의서
						<span class="color-blue" v-if="userSubmitState === 'DONE'">동의완료</span>
						<span class="color-red" v-else>미작성</span>
					</div>
				</nav-link>
				<nav-link :click="openPopupPlan">
					<div class="round-box round-box-sm">
						사업계획서
						<!--						<span class="color-blue">등록</span>-->
						<span class="color-red" v-if="finalPlanState === 'NOT_APPROVE'">미승인</span>
						<span class="color-yellow" v-else-if="finalPlanState === 'STANDBY'">승인대기</span>
						<span class="color-blue" v-else-if="finalPlanState === 'APPROVE'">승인완료</span>
						<span class="color-red" v-else>미등록</span>
					</div>
				</nav-link>
			</div>
		</div>
		<section class="round-container">
			<div class="mybusiness-company-info">
				<div class="block">
					<nav-link class="company-link" :url="'/mybusiness/info/' + (isCompany ? userSeqNo : companySeqNo)">
						<div class="title">
							<span v-text="!isCompany ? companyNmKor : oktaUserNmKor">팜피주식회사</span>
							<span class="company-tp" v-if="!isCompany">[ {{ businessTpNm }} TP ] <font-awesome-icon class="arrow" icon="chevron-right"/></span>
							<span class="company-tp" v-else>[ {{ countryNm }} | {{ regionNm }} ] <font-awesome-icon class="arrow" icon="chevron-right"/></span>
						</div>
					</nav-link>
				</div>
				<div class="block half" v-if="!isCompany">
					<div class="col-header">사업자등록번호</div>
					<div class="col-contents">{{ registrationNo }}</div>
				</div>
				<div class="block half">
					<div class="col-header">협약기간</div>
					<div class="col-contents">
						{{ agreementDate }}
					</div>
				</div>
				<div class="block half mobile-hide" v-if="isCompany"></div>
				<div class="block half" style="width: 100%">
					<div class="col-header">협약프로그램</div>
					<div class="col-contents">{{ programName }}</div>
				</div>
				<!--				<div class="block half"></div>-->
			</div>
		</section>

		<div>
			<h2 class="mt30">관리자메모</h2>
			<section class="round-container">
				<div class="mybusiness-admin-memo">
					<pre>{{ adminMemo }}</pre>
				</div>
			</section>
		</div>

		<section>
			<h2 class="mt30">사업진행정보</h2>
			<div class="round-container">
				<section class="table-area">
					<div class="table-header mobile-hide" ref="table">
						<div class="col-auto">상태</div>
						<div>내용</div>
						<div class="col-auto">처리자</div>
						<div class="col-auto">처리일</div>
					</div>
					<!-- web -->
					<article class="table-list mobile-hide" v-for="(plog, i) in plogs" v-bind:key="i">
						<div class="col-auto mobile-hide">{{ plog.logStateDesc }}</div>
						<div class="mobile-hide" v-if="plog.logReportType === 'PROGRAM'">{{ plog.logProgramTitle + ' ' + plog.logDesc }}</div>
						<div class="mobile-hide" v-else-if="plog.logReportType === 'MONTHLY'">{{ '월별(' + plog.logReportYm + ') ' + plog.logDesc }}</div>
						<div class="mobile-hide" v-else-if="plog.logReportType === 'FINAL'">{{ '최종 ' + plog.logDesc }}</div>
						<div class="mobile-hide" v-else-if="plog.logReportType === 'FILE'">{{ plog.logDesc }}</div>
						<div class="col-auto mobile-hide">{{ plog.regUserName }}</div>
						<div class="col-auto mobile-hide">{{ $moment(plog.regDate).format('YYYY-MM-DD') }}</div>
					</article>
					<!--   mobile   -->
					<article class="table-list web-hide" v-for="(plog, i) in plogs" v-bind:key="'plogs_mobile_' + i">
						<div class="col-title" v-if="plog.logReportType === 'PROGRAM'">{{ plog.logProgramTitle + ' ' + plog.logDesc }}</div>
						<div class="col-title" v-else-if="plog.logReportType === 'MONTHLY'">{{ '월별(' + plog.logReportYm + ') ' + plog.logDesc }}</div>
						<div class="col-title" v-else-if="plog.logReportType === 'FINAL'">{{ '최종 ' + plog.logDesc }}</div>
						<div class="col-title" v-else-if="plog.logReportType === 'FILE'">{{ plog.logDesc }}</div>
						<div class="col-date col-line">{{ plog.regUserName }}</div>
						<div class="col-date">{{ $moment(plog.regDate).format('YYYY-MM-DD') }}</div>
					</article>
				</section>
			</div>
		</section>

		<section>
			<h2 class="mt30">프로그램별 보고서</h2>
			<div class="round-container" v-if="agreementState === 'DONE'">
				<div class="mybusiness-program-report" v-for="(programVO, i) in programReportList" :key="programVO.programCode">
					<div class="cursor" @click="reportClick(programVO.programCode, programVO.reportState)" v-if="programVO.programCode != 'P14'">
						<div class="block half" :class="[{ 'br-b-0': programReportList.length === i + 1 }]">
							<div class="title project-label">
								<label
									class="font-bold cursor"
									:class="[
										{
											'etc-title':
												programVO.programNm === '기타1' ||
												programVO.programNm === '기타2' ||
												programVO.programNm === '기타3' ||
												programVO.programNm === '기타4',
										},
									]"
									>{{ programVO.programNm }}
									<label
										class="cursor"
										v-if="
											(programVO.programNm === '기타1' ||
												programVO.programNm === '기타2' ||
												programVO.programNm === '기타3' ||
												programVO.programNm === '기타4') &&
												programVO.etcProgramNm !== null &&
												programVO.etcProgramNm !== ''
										"
										><br />({{ programVO.etcProgramNm }})</label
									>
								</label>
							</div>
							<div class="display-block">
								<font-awesome-icon
									class="arrow"
									:class="[
										{
											'':
												programVO.programNm === '기타1' ||
												programVO.programNm === '기타2' ||
												programVO.programNm === '기타3' ||
												programVO.programNm === '기타4',
										},
									]"
									icon="chevron-right"
								/>
							</div>
						</div>

						<div
							class="block half"
							:class="[
								{
									'br-b-0': programReportList.length === i + 1,
									'etc-padding':
										(programVO.programNm === '기타1' ||
											programVO.programNm === '기타2' ||
											programVO.programNm === '기타3' ||
											programVO.programNm === '기타4') &&
										programVO.etcProgramNm !== null &&
										programVO.etcProgramNm !== '',
								},
							]"
						>
							<div class="col-header mobile-hide">제출일</div>
							<div class="col-contents list-date">
								{{
									(programVO.reportState === 'DONE' || programVO.reportState === 'CONFIRM') && programVO.modDate
										? $moment(programVO.modDate).format('YY.MM.DD')
										: '-'
								}}
							</div>
							<div class="col-header">
								<span class="color-green" v-if="programVO.reportState === 'DONE'">작성완료</span>
								<span class="color-blue" v-else-if="programVO.reportState === 'CONFIRM'">승인완료</span>
								<span class="color-yellow" v-else-if="programVO.reportState === 'MODIFY'">수정요청</span>
								<span class="color-mushroom" v-else>미작성</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<section class="round-container" v-else>
				<div class="pa-4 text-center">
					<h5 class="mt-2">협약이 완료되지 않았습니다</h5>
				</div>
			</section>
		</section>

		<section>
			<h2 class="mt30">최종보고서</h2>
			<div class="round-container cursor" v-if="agreementState === 'DONE'">
				<div class="mybusiness-final-report cursor" @click="reportClick('FINAL', finalReportInfo.reportState)">
					<div class="block half cursor">
						<div class="title cursor">
							<label class="label-line font-bold cursor">최종보고서</label>
						</div>
					</div>
					<div class="block half cursor">
						<div class="col-header mobile-hide">제출일</div>
						<div class="col-contents">
							{{
								(finalReportInfo.reportState === 'DONE' || finalReportInfo.reportState === 'CONFIRM') && finalReportInfo.modDate
									? this.$moment(finalReportInfo.modDate).format('YY.MM.DD')
									: '-'
							}}
						</div>
						<div class="col-header color-red" v-if="finalReportInfo.reportState === 'MODIFY'">수정요청</div>
						<div class="col-header color-green" v-else-if="finalReportInfo.reportState === 'DONE'">작성완료</div>
						<div class="col-header color-blue" v-else-if="finalReportInfo.reportState === 'CONFIRM'">승인완료</div>
						<div class="col-header color-mushroom" v-else>미작성</div>
						<!-- 미작성 color-mushroom / 수정요청 color-red / 작성완료 color-green / 승인완료 color-blue -->
					</div>
				</div>
			</div>
			<section class="round-container" v-else>
				<div class="pa-4 text-center">
					<h5 class="mt-2">협약이 완료되지 않았습니다</h5>
				</div>
			</section>
		</section>

		<div class="title-with-right-button-area">
			<h2 class="mt40">월별보고서</h2>
			<div class="report-example">
				<div class="float-left mr-3"><span class="mr-2 color-Mushroom">■</span>미작성</div>
				<div class="float-left mr-3"><span class="mr-2 color-green">■</span>작성완료</div>
				<div class="float-left mr-3"><span class="mr-2 color-blue">■</span>승인완료</div>
				<div class="float-left mr-3"><span class="mr-2 color-red">■</span>수정요청</div>
				<!--        <div class="float-left mr-3" v-if="!isCompany"><span class="mr-2 color-red">■</span>수정요청</div>-->
			</div>
		</div>
		<table cellspacing="0" cellpadding="0" class="online-report-box mb-8" id="reportTable" :ref="'reportTable'" v-if="agreementState === 'DONE'">
			<tr v-for="(rowList, i) in monthlyReportList" v-bind:key="i">
				<td
					v-for="(reportVO, j) in rowList"
					v-bind:key="j"
					:class="[
						{ 'mobile-line': j % 2 === 1 },
						{ active: onReportYm === reportVO.reportYm },
						{ cursor: reportVO.reportYm != null },
						{ 'mobile-under-br': monthlyReportList.length === i + 1 && (j === 4 || j === 5 || j === 10 || j === 11) },
					]"
					@click="reportClick(reportVO.reportYm, reportVO.isWrite)"
				>
					<div v-if="reportVO.reportYm != null">
						<span class="color-blue" v-if="reportVO.isWrite === 'CONFIRM'">■ </span>
						<span class="color-green" v-else-if="reportVO.isWrite === 'DONE'">■ </span>
						<span class="color-red" v-else-if="reportVO.isWrite === 'MODIFY' && !isCompany">■ </span>
						<!--						<span class="color-green" v-else-if="reportVO.isWrite === 'CONFIRM' && !isCompany">■ </span>-->
						<span class="color-Mushroom" v-else>■ </span>
						<span>{{ reportVO.year + '년 ' + reportVO.month + '월' }}</span>
					</div>
					<div v-else>-</div>
				</td>
			</tr>
		</table>

		<section class="round-container round-container-size" v-else>
			<div class="pa-4 text-center onlinebox">
				<h5 class="mt-2">협약이 완료되지 않았습니다</h5>
			</div>
		</section>

		<section class="basic-container report" v-if="onReportYm !== ''">
			<!-- <OnlineReportOne ref="reportTypeOne" :reportYm="reportYm" :matchSeqNo="matchSeqNo" /> -->
			<!--			&& interimReportFinalDone === 'DONE'-->

			<!--			<div class="btn-area" v-if="isCompany">-->
			<!--				<button class="pinkBtn" @click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_REPORT_COMMENT)">중소기업 의견제출</button>-->
			<!--			</div>-->
		</section>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';
// import OnlineReportOne from '@/components/mybusiness/Online-Report-One';
import moment from 'moment-timezone';

export default {
	title: '내비즈니스상세',
	name: 'MyBusinessDetail',
	// components: { OnlineReportOne },
	props: ['matchSeqNo', 'reportYm'],
	data: function() {
		return {
			loginMember: null,
			eventBus,
			CONST,
			select: 1,
			apiData: [],
			plogs: [],
			userSeqNo: '',
			companySeqNo: '',
			programReportList: null,
			monthlyReportList: null,
			finalReportInfo: {
				reportType: 'FINAL',
				reportState: 'NONE',
				regDate: '-',
				modDate: null,
			},
			oktaUserNmKor: 'OKTA회원명',
			companyNmKor: '새싹기업명',
			programName: '협약된 프로그램이 없습니다.',
			agreementDate: '협약이 완료되지 않았습니다.',
			registrationNo: '123-234-987654',
			countryNm: '',
			regionNm: '',
			businessTpNm: '',
			adminMemo: '',
			finalPlanState: 'NONE',
			userSubmitState: 'NONE',
			onReportYm: '',
			reportState: 'NONE',
			agreementState: 'NONE',
			agreeMsg: '작성되지 않은 상태: 미작성 <br/>작성중 상태: 작성중<br/> 작성이 완료된 상태: 작성완료<br/>',
		};
	},
	created() {
		eventBus.$on('LOAD_POPUP_AGREEMENT_DATA', () => {
			this.getBusinessDetail(() => {
				this.openAgreement();
			});
		});
		eventBus.$on('LOAD_POPUP_VISIT_DATA', () => {
			this.getBusinessDetail(() => {
				this.openPopupPlan();
			});
		});
	},
	mounted() {
		document.body.style.overflow = 'scroll';

		eventBus.$emit(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.getBusinessDetail();
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.SAVE_REPORT_COMMENT);
	},
	watch: {
		matchSeqNo: function() {
			this.getBusinessDetail();
		},
	},
	computed: {
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
		// contractComplete() {
		// 	return this.apiData && this.apiData.userSubmitState === 'CONFIRM' && this.apiData.companySubmitState === 'CONFIRM';
		// },
		// currentDay() {
		// 	//TODO 임시해제
		// 	// return this.onReportYm === this.$moment().format('YYYY-MM');
		// 	return true;
		// },
	},
	methods: {
		// onTableResize: function() {
		// 	let reportTable = this.$refs.reportTable;
		// 	let finalTd = this.$refs.finalTd;
		// 	let totalWidth = window.innerWidth;
		// 	if (this.apiData.stateCd === 'GROW') {
		// 		if (totalWidth <= 768) {
		// 			reportTable.lastChild.appendChild(finalTd[0]);
		// 		} else {
		// 			reportTable.firstChild.appendChild(finalTd[0]);
		// 		}
		// 	}
		// },
		// showRejectReason: function(v) {
		// 	if (v === 'SWIFT') return 'SWIFT 오류';
		// 	else if (v === 'ACCOUNT') return '계좌 오류';
		// 	return '-';
		// },
		// doCompanyMemoSave: function() {
		// 	if (!this.isCompany) {
		// 		alert('권한이 없습니다.');
		// 		return false;
		// 	}
		//
		// 	if (this.companyMemo === '') {
		// 		alert('의견을 작성하지 않았습니다.');
		// 		return false;
		// 	}
		//
		// 	let formData = new FormData();
		// 	formData.append('companyMemo', this.companyMemo);
		// 	formData.append('matchSeqNo', this.matchSeqNo);
		// 	formData.append('reportYm', this.onReportYm);
		//
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/business/updateReport/CompanyComment.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				alert('저장되었습니다.');
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
		reportClick: function(reportYm, reportState) {
			if (reportYm == null) {
				return false;
			}

			if (this.isCompany && reportState !== 'CONFIRM') {
				alert('보고서가 승인되지 않았습니다.');
				this.onReportYm = '';
				return false;
			}

			//TODO 임시해제
			// console.log('this.isCompany', this.isCompany, 'this.apiData.approveFCd', this.apiData.approveFCd);
			// if (this.isCompany && this.apiData.approveFCd === 'REFUND') {
			// 	alert('환불된 사업입니다.');
			// 	return false;
			// }
			// if (this.isCompany && this.apiData.approveFCd !== 'APPROVE') {
			// 	alert('승인되지 않은 사업입니다.');
			// 	return false;
			// }

			// if (this.loginMember.budsUserType !== CONST.USER_TYPE.COMPANY && this.reportYm !== this.$moment().format('YYYY-MM') && reportState === 'NONE') {
			// 	alert('보고서는 해당 월에만 작성이 가능합니다.');
			// 	this.onReportYm = '';
			// 	return false;
			// }

			if (reportYm === 'FINAL') {
				this.$device.pushView('/mybusiness/final/' + this.matchSeqNo);
			} else if (reportYm.indexOf('P') > -1) {
				this.$device.pushView('/mybusiness/' + reportYm + '/' + this.matchSeqNo);
			} else {
				this.reportState = reportState;
				this.onReportYm = reportYm;
				// this.$device.pushView('/mybusiness/detail/' + this.matchSeqNo + '/' + this.onReportYm);
				this.$device.pushView('/mybusiness/monthly/' + this.matchSeqNo + '/' + this.onReportYm);
			}
		},
		openAgreement: function() {
			let body = document.getElementsByTagName('body')[0];
			body.classList.add('not-scroll');
			let param = this.apiData;
			eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'modalAgree', '사업비관리 동의서', param);
		},
		openPopupPlan: function() {
			let body = document.getElementsByTagName('body')[0];
			body.classList.add('not-scroll');
			if (this.apiData.userSubmitState !== 'DONE') {
				alert('사업비관리동의서를 동의하지 않았습니다.');
				return false;
			}
			let param = {
				matchSeqNo: this.apiData.matchSeqNo,
				userSeqNo: this.apiData.userSeqNo,
				companySeqNo: this.apiData.companySeqNo,
			};
			eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'modalPlan', '사업계획서', param);
		},
		getBusinessDetail: function() {
			this.apiData = [];
			let formData = new FormData();
			formData.append('matchSeqNo', this.matchSeqNo);
			formData.append('userGrdCode', this.loginMember.budsUserType);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getBusinessDetail.do', formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
						this.$device.pushView('/mybusiness');
					} else {
						if (res.data.data != null) {
							this.apiData = res.data.data;
							this.companySeqNo = this.apiData.companySeqNo;
							this.userSeqNo = this.apiData.userSeqNo;
							this.registrationNo = this.$options.filters['registrationNoOnly'](this.apiData.registrationNo);
							this.companyNmKor = this.apiData.companyNmKor;
							this.oktaUserNmKor = this.apiData.oktaUserNmKor;
							this.userSubmitState = this.apiData.userSubmitState;
							this.finalPlanState = this.apiData.finalPlanState;
							this.businessTpNm = this.apiData.businessTpNm;
							this.countryNm = this.apiData.countryNm;
							this.regionNm = this.apiData.regionNm;
							this.adminMemo = this.apiData.adminMemo;

							this.getReportPlogs();

							//협약
							if (this.apiData.agreementState === 'DONE') {
								this.agreementState = this.apiData.agreementState;
								this.agreementDate =
									this.$moment(moment(this.apiData.agreementStartDate).tz('Asia/Seoul')).format('YYYY-MM-DD') +
									' ~ ' +
									this.$moment(moment(this.apiData.agreementEndDate).tz('Asia/Seoul')).format('YYYY-MM-DD');

								this.getLoadingFinalReport();
								this.getProgramReportList();
								this.getMonthlyReportList();
							}

							this.$device.removeLocalData('MATCH_DATA');
							this.$device.saveLocalData('MATCH_DATA', JSON.stringify(this.apiData));
						}
						// this.$nextTick(() => {
						// 	this.onTableResize();
						// });
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
		getLoadingFinalReport: function() {
			//최종보고서
			if (this.apiData.reportList && this.apiData.reportList.length > 0) {
				for (let i = 0; i < this.apiData.reportList.length; i++) {
					if (this.apiData.reportList[i].reportType === 'FINAL') {
						this.finalReportInfo = this.apiData.reportList[i];
					}
				}
			}
		},
		getProgramReportList: function() {
			//프로그램별 보고서
			if (this.apiData.programList && this.apiData.programList.length > 0) {
				//협약프로그램
				this.programName = '';
				let count = 0;
				for (let i = 0; i < this.apiData.programList.length; i++) {
					count++;
					this.programName += this.apiData.programList[i].programNm + (count === this.apiData.programList.length ? '' : ', ');
					if (
						this.apiData.programList[i].programNm === '기타' &&
						this.apiData.programList[i].etcProgramNm !== null &&
						this.apiData.programList[i].etcProgramNm !== ''
					) {
						this.programName += '(' + this.apiData.programList[i].etcProgramNm + ')';
					}
				}
				//프로그램별 보고서 리스트
				this.programReportList = this.apiData.programList;
				if (this.apiData.reportList && this.apiData.reportList.length > 0) {
					for (let i = 0; i < this.apiData.reportList.length; i++) {
						if (this.apiData.reportList[i].reportType === 'PROGRAM') {
							for (let j = 0; j < this.programReportList.length; j++) {
								if (this.apiData.reportList[i].programCode === this.programReportList[j].programCode) {
									this.programReportList[j].reportState = this.apiData.reportList[i].reportState;
									this.programReportList[j].regDate = this.apiData.reportList[i].regDate;
									this.programReportList[j].modDate = this.apiData.reportList[i].modDate;
									this.programReportList[j].seqNo = this.apiData.reportList[i].seqNo;
								}
							}
						}
					}
				} else {
					for (let i = 0; i < this.programReportList.length; i++) {
						this.programReportList[i].reportState = 'NONE';
					}
				}
			}
		},
		getMonthlyReportList: function() {
			//월별보고서
			let allMonthlyReportList = [];
			let reportCheckList = [];

			let agreementStartDate = this.$moment(this.apiData.agreementStartDate).format('YYYY-MM-DD');
			let agreementEndDate = this.$moment(this.apiData.agreementEndDate).format('YYYY-MM-DD');

			let startMonthly = agreementStartDate.split('-');
			let endMonthly = agreementEndDate.split('-');
			let da1 = new Date(startMonthly[0], Number(startMonthly[1]) - 1);
			let da2 = new Date(endMonthly[0], endMonthly[1]);
			let dif = da2 - da1;
			let cDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨
			let cMonth = cDay * 30; // 월 만듬
			let agreementMonthlyCount = parseInt(dif / cMonth);

			for (let i = 0; i < agreementMonthlyCount; i++) {
				let reportDate = this.$moment(agreementStartDate)
					.add(i, 'M')
					.format('YYYY-MM');
				allMonthlyReportList.push({
					reportYm: reportDate,
				});
			}

			var reportMonthCount = agreementMonthlyCount > 6 ? 12 : 6;
			var bal = reportMonthCount === 12 ? 'two' : 'one';
			if (bal === 'two') {
				reportCheckList.push(new Array());
				reportCheckList.push(new Array());
			} else {
				reportCheckList.push(new Array());
			}
			for (let i = 0; i < reportMonthCount; i++) {
				let found = false;
				let status = '';
				let reportSeqNo = 0;
				let reportYm = null;

				if (allMonthlyReportList[i] != null) {
					reportYm = allMonthlyReportList[i].reportYm;
				}

				//리포트가 있다면
				if (this.apiData.reportList && this.apiData.reportList.length > 0) {
					for (var j = 0; j < this.apiData.reportList.length; j++) {
						if (this.apiData.reportList[j].reportType === 'MONTHLY') {
							if (this.apiData.reportList[j].reportYm === reportYm) {
								found = true;
								status = this.apiData.reportList[j].reportState;
								reportSeqNo = this.apiData.reportList[j].seqNo;
								reportYm = this.apiData.reportList[j].reportYm;
							}
						}
					}
				}
				if (i < 6) {
					reportCheckList[0].push({
						isWrite: found ? status : 'NONE',
						reportSeqNo: found ? reportSeqNo : '',
						reportYm: reportYm,
						year: this.$moment(reportYm).format('YYYY'),
						month: this.$moment(reportYm).format('MM'),
					});
				} else {
					reportCheckList[1].push({
						isWrite: found ? status : 'NONE',
						reportSeqNo: found ? reportSeqNo : '',
						reportYm: reportYm,
						year: this.$moment(reportYm).format('YYYY'),
						month: this.$moment(reportYm).format('MM'),
					});
				}
			}
			this.monthlyReportList = reportCheckList;
			// this.$device.saveLocalData('REPORT_TABLE', JSON.stringify(this.reportCheckList));
		},
		getReportPlogs: function() {
			this.plogs = [];
			let formData = new FormData();
			formData.append('matchSeqNo', this.matchSeqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getReportPlogs.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						if (res.data.data) {
							this.plogs = res.data.data;
						}
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
		// getLoadingMonthlyReportData: function() {
		// 	let formData = new FormData();
		// 	formData.append('matchSeqNo', this.matchSeqNo);
		// 	formData.append('reportYm', this.onReportYm);
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/business/getReportInfo.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				// this.$device.removeLocalData('REPORT_VO');
		// 				// this.$device.removeLocalData('REPORT_LIST_VO');
		// 				// this.$device.removeLocalData('REPORT_META_LIST');
		// 				// this.$device.removeLocalData('REPORT_GROW_FILE_LIST');
		// 				// this.$device.removeLocalData('REPORT_OLD_A05_FILE_LIST');
		// 				// if (res.data.data.reportVO !== null) {
		// 				// 	this.$device.saveLocalData('REPORT_VO', JSON.stringify(res.data.data.reportVO));
		// 				// this.$device.saveLocalData('REPORT_LIST_VO', JSON.stringify(res.data.data.reportListVO));
		// 				// this.$device.saveLocalData('REPORT_META_LIST', JSON.stringify(res.data.data.metaList));
		// 				// this.$device.saveLocalData('REPORT_GROW_FILE_LIST', JSON.stringify(res.data.data.growMonthFileList));
		// 				// this.$device.saveLocalData('REPORT_OLD_A05_FILE_LIST', JSON.stringify(res.data.data.oldA05FileList));
		// 				// 	this.reportState = res.data.data.reportVO.reportState;
		// 				// 	this.reportSeqNo = res.data.data.reportVO.seqNo;
		// 				// 	this.companyMemo = res.data.data.reportVO.companyMemo;
		// 				// 	this.$refs.reportTypeOne.loadReportData();
		// 				// } else {
		// 				// 	this.$refs.reportTypeOne.setReportForm();
		// 				// }
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
	},
};
</script>

<style scoped></style>
